import { LiveEventNameScreen } from '@/screens/index'

export default function () {
  return <LiveEventNameScreen />
}
